export const WELCOME_TEXT = "activation.home.title.with.name";
